import { createSelector } from 'reselect';

import { getDealsColumns } from '../declarations/deals/deals';
import { getDealFilterCriteriaContainers } from '../declarations/filter/filter';
import { DealsSourceHelper } from '../service/DealsSourceHelper';
import { ColumnsSettingsViewDict } from '../typings/common';
import { DealsCacheKeysDict, DealsScreenUrlSearchParam, DealsSourceParams } from '../typings/deals';
import { CriteriaContainer, FilterPartialExpression } from '../typings/filter';
import { GridSourceParams } from '../typings/grid';
import { State } from '../typings/state';

export const selectDealsSourceParams = createSelector(
    (state: State) => {
        const { sourceParams } = state.deals;
        return Object.assign({}, sourceParams);
    },
    (res: DealsSourceParams): DealsSourceParams => res
);

export const selectDealsFilterExpressions = createSelector(
    selectDealsSourceParams,
    (sourceParams: DealsSourceParams): FilterPartialExpression[] => {
        if (!sourceParams || !sourceParams.filter) {
            return [];
        }

        return sourceParams.filter;
    }
);

export const selectDealsFilterContainers = createSelector(
    selectDealsSourceParams,
    (params: DealsSourceParams): CriteriaContainer[] => {
        if (!params) {
            return [];
        }

        return getDealFilterCriteriaContainers();
    }
);

export const selectDealsCacheKey = createSelector(
    selectDealsSourceParams,
    (state: State) => state.deals.dealsCacheKeysDict,
    (sourceParams: GridSourceParams, dealsCacheKeysDict: DealsCacheKeysDict): string =>
        dealsCacheKeysDict.get(
            JSON.stringify({
                ...sourceParams
            })
        ) || ''
);

export const selectDealsColumns = createSelector(
    (state: State) => state.deals.columnsSettings,
    (columnsSettings: ColumnsSettingsViewDict) => {
        return getDealsColumns(columnsSettings);
    }
);

export const selectNormalizedDealsSourceParams = createSelector(
    (state: State) => state.commonData.login,
    (state: State) => state.router.search,
    (login: string, search: string) => {
        const params = new URLSearchParams(search);

        return DealsSourceHelper.normalizeSourceParams({
            sortKey: params.get(DealsScreenUrlSearchParam.sortKey) || '',
            sortDirection: params.get(DealsScreenUrlSearchParam.sortDirection) || '',
            login: login || params.get(DealsScreenUrlSearchParam.ulogin) || '',
            filter: params.get(DealsScreenUrlSearchParam.filter) || '',
            noStats: params.get(DealsScreenUrlSearchParam.noStats) || ''
        });
    }
);
